import "./styles.css";
import { useLoaderData, useRouteError } from "react-router-dom";
import Profile from "../../../components/membru-cd";
import ResourceDisplay from "../../../components/resource-display";
import GenericErrorDisplay from "../../generic-error";
import ResourceService from "../../../service/resource";
import PersonService from "../../../service/person";

export const path = "cd/";

const resourceKeys = {
  header: "about-cd-header-oameni",
  text: "about-cd-header-text",
};

export async function loader() {
  const resourcesArray = new ResourceService().read.byIds(
    Object.values(resourceKeys)
  );
  const cdPeople = new PersonService().read.byGroup("cd");
  return [await resourcesArray, await cdPeople];
}

export function Component() {
  const [resources, cdPeople] = useLoaderData();

  return (
    <div id="page-cd">
      <div className="header">
        <div className="title">
          <h2>Consiliul Director</h2>
        </div>
        <div className="content-text">
          <ResourceDisplay
            className="header-text"
            resource={resources[resourceKeys.text]}
          ></ResourceDisplay>
        </div>
        <div className="image1c">
          <ResourceDisplay
            className="image1"
            resource={resources[resourceKeys.header]}
          ></ResourceDisplay>
        </div>
      </div>
      <div className="body">
        <div className="Membru-CD">
          {cdPeople.map((person, index) => {
            return (
              <Profile
                nume={person.name}
                functie={person.position}
                email={person.email}
                image={person.profile}
                descriere={person.description}
                reverse={index % 2 === 0}
                key={person.id}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
Component.displayName = "page-about-cd";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-about-cd-error";
